// config.js  
const config = {  
    domain: 'http://120.76.201.89:8001/'  
  };  
    
  export default config;